import s from '../allservices.jsx';
import { getClientId, getClientSecret,buildClientHeader } from '../../utils/clientAuth.js';

export const getCardActivityService = (actionCallback, id, startDate, endDate, statementPeriod,transactionType) => {
    let token = "Token " + localStorage.getItem('token')
    let plink =  localStorage.getItem('pform')==='AU'? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ 
    const state = {
        activityFromDate: startDate || "",
        activityToDate: endDate || "",
        applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex',
        cardDetailsId: id,
        statementPeriod: statementPeriod ,
        transactionType:transactionType
    }
    let traceId = getClientId();
    fetch(plink + s.get_cardactivity,{
        method: "POST",
        headers: {
            'content-type': 'application/json',
            'Authorization': token,
            'X-Trace-Id': traceId,
            'X-KlickEx-Client':buildClientHeader(),
        },
        body: JSON.stringify(state)

    })
    .then(res => {
        if (res.status === 200 || res.status === 201) {
            res.json().then(json => actionCallback(json, "success", res.status))
        } else if (res.status === 204) {
            actionCallback({ "transactions": [] }, "emptyBody", res.status)
        } else {
            actionCallback([], res.headers.get('message'), res.status)
        }
    })
}


// WEBPACK FOOTER //
// ./src/services/components/get_cardactivity.jsx